import { makeStyles, createStyles } from '@material-ui/core/styles';

export const styles = makeStyles(theme =>
  createStyles({
    submissionCyclesContainer: {
      marginBottom: 8,
      '& > :first-child': {
        marginTop: 8
      }
    },
    submissionCycleCard: {
      borderRadius: '5px',
      backgroundColor: '#fff',
      border: 'solid 1px #ededed',
      boxShadow: '0 2px 8px 0 rgba(37, 37, 37, 0.03)'
    },
    submissionCycleHeader: {
      borderRadius: '5px',
      boxShadow: 'inset 0 -1px 0 0 #eaeaea'
    },
    rectDate: {
      padding: '0 16px',
      margin: '8px 16px',
      borderRadius: '5px',
      backgroundColor: '#f9fafc'
    },
    rectDateNumber: {
      fontSize: 36,
      opacity: 0.65,
      color: '#383d45',
      lineHeight: 1.33,
      textAlign: 'center',
      letterSpacing: 'normal',
      fontFamily: 'Lato-SemiBold'
    },
    rectDateMon: {
      fontSize: 12,
      marginTop: -8,
      color: '#2c2c2c',
      textAlign: 'center',
      letterSpacing: '0.1px',
      fontFamily: 'Lato-SemiBold'
    },
    responsesStatus: {
      fontSize: 16,
      marginLeft: 8,
      color: '#73777b',
      letterSpacing: 0.13,
      fontFamily: 'Lato-SemiBold'
    },
    responsesNumbers: {
      color: '#474f58',
      fontWeight: 'bold',
      fontFamily: 'Lato'
    },
    separationPoint: {
      width: 6,
      height: 6,
      margin: '0 24px',
      borderRadius: '50%',
      verticalAlign: '8%',
      display: 'inline-block',
      backgroundColor: '#d8d8d8'
    },
    submissionWord: {
      fontSize: 16,
      marginRight: 8,
      color: '#474f58',
      letterSpacing: 0.13,
      fontFamily: 'Lato-SemiBold'
    },
    submissionStatus: {
      fontSize: 16,
      marginRight: 16,
      letterSpacing: 0.13,
      fontFamily: 'Lato-Bold'
    },
    submissionStatusOpen: {
      color: '#f5a623'
    },
    submissionStatusClosed: {
      color: '#7ed321'
    },
    expandCard: {
      opacity: '0.5',
      color: '#858d9b'
    },
    notSubmittedMembers: {
      marginTop: 16,
      marginBottom: 24,
      borderBottom: 'solid 1px #ededed'
    },
    alertRoot: {
      minHeight: 40,
      borderRadius: 8,
      padding: '0 16px',
      backgroundColor: 'rgba(199, 218, 255, 0.2)',
      '@media only screen and (max-width: 320px)': {
        padding: '0 8px'
      }
    },
    alertMessage: {
      fontSize: 16,
      color: '#1c3d80',
      letterSpacing: 0.13,
      display: 'inline-block',
      fontFamily: 'Lato-Bold !important'
    },
    alertIcon: {
      marginTop: 5,
      marginRight: 8,
      color: '#1c3d80'
    },
    alertAction: {
      opacity: 0.8,
      fontSize: 16,
      color: '#3a78f2',
      letterSpacing: 0.13,
      textTransform: 'none',
      fontFamily: 'Lato-Bold'
    },
    notSubmittedMembersContainer: {
      padding: '8px 16px'
    },
    emptyResponses: {
      color: '#474f58',
      marginBottom: 24
    },
    responsesHeaderContainer: {
      padding: '0 24px'
    },
    responsesTitleContainer: {
      marginTop: -16
    },
    responsesIcon: {
      marginRight: 8
    },
    responsesTitle: {
      fontSize: 16,
      color: '#000',
      marginTop: -5,
      fontFamily: 'Lato-Bold',
      letterSpacing: 'normal'
    },
    formControl: {
      '@media (max-width: 367px)': {
        margin: '24px 0'
      }
    },
    label: {
      zIndex: 5,
      marginLeft: 3,
      marginTop: -16
    },
    groupingSelect: {
      height: 32,
      borderRadius: 6,
      backgroundColor: '#fff',
      border: 'solid 1px rgba(224, 224, 224, 0.49)',
      boxShadow: '0 2px 5px 0 rgba(219, 219, 219, 0.5)'
    },
    '@media (max-width: 320px)': {
      rectDate: {
        textAlign: 'center'
      },
      responsesStatus: {
        marginLeft: 16
      },
      separationPoint: {
        display: 'none'
      },
      submissionWord: {
        marginLeft: 16
      }
    },
    gridSeparator: {
      paddingTop: 24
    }
  })
);
